import { AxiosResponse } from 'axios';
import { ReportListVM } from 'civil-status/view-models/research-report';
import { DateTime } from 'luxon';
import { NewHttpResponseList } from 'shell/models/http-response';
import { ResponseReport } from 'shell/models/response-report';

export const transformReportList = (
  response: AxiosResponse<NewHttpResponseList<ResponseReport>>
): Array<ReportListVM> => {
  const data = response.data.payload || [];
  const pageInfo = response.data?.pageInfo;

  return data.map((item) => ({
    totalCount: pageInfo.totalCount,
    holders: `${item.cognome || ''} ${item.nome || ''}${
      item.cognome2 || item.nome2 ? `; ${item.cognome2 || ''} ${item.nome2 || ''}` : ''
    }`,
    register: item.registro || '',
    idAnsc: item.idAnsc || '',
    dateFormation: item.formazioneAtto
      ? DateTime.fromISO(item.formazioneAtto).toFormat('dd/MM/yyyy')
      : '',
    operator: item.cognomeNomeOperatore || '',
    typeContent: item.tipoContenuto || '',
    typology: item.tipoAtto || '',
    state: item.codiceStato || '',
    service: item.codiceServizio || '',
  }));
};
